function asciiToArray(r){return r.split("")}module.exports=asciiToArray;